const contractorRolesOptions = [
  {
    "value": "CARRIER",
    "label": "contractor.table.roles.carrier"
  },
  {
    "value": "CLIENT",
    "label": "contractor.table.roles.client"
  },
  {
    "value": "INSURER",
    "label": "contractor.table.roles.insurer"
  }
]
export default contractorRolesOptions
